import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const LNBHeader = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="cont_info">
      {children}
    </div>
  );
});

LNBHeader.displayName = 'LNBHeader';

export default LNBHeader;
